import axiosInstance from "./axiosInstance";

export const getSuperContainerList = () => {
  return axiosInstance.get(`superContainers/getSuperContainerList`);
};

export const getContainersList = (params) => {
  return axiosInstance.get(`containers`, { params: params });
};

export const getCharacterizationContainersList = (params = {}) => {
  return axiosInstance.get(`containers/characterization`, { params });
};

export const updateContainer = (params, id) => {
  return axiosInstance.post(`container/update/${id}`, params);
};

export const validateMidCycleFluxChange = (id) => {
  return axiosInstance.post(`container/validateMidCycleFluxChange/${id}`);
};

export const getHistoryCycleContainer = (params, id, signal) => {
  return axiosInstance.get(`container/historyCycleContainer/${id}`, {
    params: params,
    signal: signal,
  });
};

export const getHistoryFillingSpeed = (id) => {
  return axiosInstance.get(`container/historyFillingSpeed/${id}`);
};

export const getContainerCharacterization = (params, id) => {
  return axiosInstance.get(`container/containerCharacterization/${id}`, {
    params: params,
  });
};

export const getHistoryActivity = (params) => {
  return axiosInstance.get(`history/activity`, { params: params });
};

export const getHistoryCollection = (params, signal) => {
  return axiosInstance.get(`history/collection`, {
    params: params,
    signal: signal,
  });
};

export const saveContainerWeight = (data) => {
  return axiosInstance.post(`container/weight`, data);
};

export const getContainerClientRegisteredInfo = (params, id, signal) => {
  return axiosInstance.get(`container/clientRegisteredInfo/${id}`, {
    params: params,
    signal: signal, // Pass the abort signal here
  });
};

export const countContainers = (params) => {
  return axiosInstance.get(`containers/count`, { params: params });
};

export const getListRotationPeriods = (params, id) => {
  const suffix = id == null || id === "" ? "" : `/${id}`;
  return axiosInstance.get(`period/listRotationPeriods${suffix}`, {
    params: params,
  });
};

export const getTemporalData = (params, id, signal) => {
  return axiosInstance.get(`temporalData/getOne/${id}`, {
    params: params,
    signal: signal, // Pass the abort signal here
  });
};

// Same route used by the backoffice (Check/Edit Temporal Data) to toggle
// boolean fields (packmat, rotation, ...) on a single history entry.
export const updateTemporalData = (measurement, dataLineUpdate) => {
  return axiosInstance.post(`temporalData/update/${measurement}`, {
    dataLineUpdate,
  });
};

export const getKeywordFilterOptions = (params) => {
  return axiosInstance.get(`getKeywordFilterOptions`, { params: params });
};

export const updateOutputSurface = (params) => {
  return axiosInstance.post(`container/outputSurface`, params);
};

export const countCategoryPropagationImpact = (params) => {
  return axiosInstance.post(
    `container/outputSurface/categoryPropagation/count`,
    params,
  );
};

export const propagateCategoryChange = (params) => {
  return axiosInstance.post(
    `container/outputSurface/categoryPropagation`,
    params,
  );
};

export const deleteSegmentation = (params) => {
  return axiosInstance.post(`container/deleteSegmentation`, params);
};

export const restoreSegmentation = (params) => {
  return axiosInstance.post(`container/restoreSegmentation`, params);
};

export const getDeletedSegmentations = (params) => {
  return axiosInstance.get(`container/getDeletedSegmentations`, {
    params: params,
  });
};

export const getAzureBlob = (params) => {
  return axiosInstance.get(`container/getAzureBlob`, { params: params });
};

export const getAzureBlobFile = (params) => {
  return axiosInstance.get(`container/getAzureBlobFile`, {
    responseType: "blob",
    params: params,
  });
};

export const azureUploadFile = (params) => {
  return axiosInstance.post(`container/azureUploadFile`, params);
};

export const azureDeleteBlob = (params) => {
  return axiosInstance.post(`container/azureDeleteBlob`, params);
};

export const updateContentCategories = (params, id) => {
  return axiosInstance.post(`/container/updateContentCategories/${id}`, params);
};

export const getContainerFillingAlert = (id) => {
  return axiosInstance.get(`container/fillingAlert/${id}`);
};

export const getWasteStatistic = (params) => {
  return axiosInstance.get(`wasteStatistic`, { params: params });
};

export const getMonthlyTrackedObjects = (params) => {
  return axiosInstance.get(`anomalies/monthly-tracked-objects`, {
    params: params,
  });
};

export const getStatisticsCollections = (params) => {
  return axiosInstance.get(`wasteStatistic/collections`, { params: params });
};

export const getStatisticsCo2Generated = (params) => {
  return axiosInstance.get(`wasteStatistic/co2Generated`, { params: params });
};

export const getPackmatPerformance = (params) => {
  return axiosInstance.get(`container/getPackmatPerformance`, {
    params: params,
  });
};

export const azurecycleAkanthasSendBusqueueRequest = (params, imageId) => {
  return axiosInstance.post(
    `azurecycleAkanthasSendBusqueueRequest/${imageId}`,
    {},
    { params: params },
  );
};

export const writeazureImage = (cameraId, params) => {
  return axiosInstance.post(`writeazureimage/${cameraId}`, params);
};

export const writeazureImageLog = (cameraId, params) => {
  return axiosInstance.post(`writeazureimagelog/${cameraId}`, params);
};

export const createCharacReview = (params) => {
  const fd = new FormData();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, String(v));
  });

  // Let the browser set Content-Type with boundary (don't set it yourself)
  return axiosInstance.post("/review/createCharacReview", fd);
};

export const addConfrontation = (params) => {
  return axiosInstance.post(`confrontation/add`, params);
};

export const getConfrontations = (params = {}) => {
  return axiosInstance.get(`confrontation/getConfrontations`, { params });
};

export const updateConfrontation = (id, params) => {
  return axiosInstance.post(`confrontation/update/${id}`, params);
};

export const deleteConfrontation = (id) => {
  return axiosInstance.post(`confrontation/delete/${id}`);
};
